import React from "react";
import Button from "../UI/Button";
import classes from "./NotLoggedIn.module.scss";

const NotLoggedIn = () => {
  const onLoginClickHandler = () => (window.location = "@login");

  return (
    <div className="h-100 w-100 d-flex align-items-center justify-content-center flex-column">
      <h2 className={`h4 ${classes.title}`}>Your session expired.</h2>
      <Button
        className={`px-4 py-1 mt-2 ${classes.btn}`}
        onClick={onLoginClickHandler}
      >
        Log in again
      </Button>
    </div>
  );
};

export default NotLoggedIn;
